// src/hooks/useSubscription.js
import { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { API } from '../api/config';

const API_URL = `${API.ASSINATURAS}/assinatura/minha`;

const useSubscription = () => {
    const { user, logout } = useContext(AuthContext);
    const [subscription, setSubscription] = useState(null);
    const [hasSubscription, setHasSubscription] = useState(false);
    const [loadingSubscription, setLoadingSubscription] = useState(true);
    const [errorSubscription, setErrorSubscription] = useState(null);

    useEffect(() => {
        const fetchSubscription = async () => {
            if (!user?.token) {
                setLoadingSubscription(false);
                return;
            }

            setLoadingSubscription(true);
            setErrorSubscription(null);

            try {
                const response = await fetch(API_URL, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    // Field is still called googleToken in the API contract,
                    // but now accepts any token type via /auth/resolve-token.
                    body: JSON.stringify({ googleToken: user.token })
                });

                if (response.status === 401) {
                    logout();
                    return;
                }

                if (!response.ok) {
                    throw new Error("Erro ao buscar informações da assinatura.");
                }

                const data = await response.json();

                // Backend couldn't resolve the token — session is invalid
                if (data.validToken === false) {
                    logout();
                    return;
                }

                setHasSubscription(data.hasSubscription);
                setSubscription(data.hasSubscription ? data.subscription : null);

            } catch (err) {
                setErrorSubscription(err.message);
                setHasSubscription(false);
                setSubscription(null);
            } finally {
                setLoadingSubscription(false);
            }
        };

        fetchSubscription();
    }, [user, logout]);

    return { subscription, hasSubscription, loadingSubscription, errorSubscription };
};

export default useSubscription;